import http from '../../../http'

const state = {
    offerInfoList: [],
    offerInfo: {},
    offerDetailInfoList: [],
    offerAttachInfoList: [],
    keywords: {
        offerCode: '',
        ownerCompany: '',
        inquiryCode: '',
        status: '',
        mtrlCategory: ''
    },
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    },

};

const mutations = {
    SET_OFFER_INFO_LIST: (state, payload)=> {
        state.offerInfoList = payload;
    },
    SET_OFFER_INFO: (state, payload)=> {
        state.offerInfo = payload;
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    },
    SET_PAGE_TOTAL(state, total) {
        state.page.total = total;
    },
    SET_OFFER_DETAIL_INFO_LIST: (state, payload)=> {
        state.offerDetailInfoList = payload;
    },
    SET_OFFER_ATTACH_INFO_LIST: (state, payload)=> {
        state.offerAttachInfoList = payload;
    },
    PUSH_OFFER_ATTACH_INFO_LIST: (state, payload)=> {
        state.offerInfo.attachList.push(payload);
    },
    RESET_OFFER_ATTACH_INFO_LIST: (state, payload)=> {
        state.offerInfo.attachList = payload;
    }
};

const actions = {
    getOfferInfoList: ({commit}, payload) =>{
        let params = {};
        params.current = state.page.current;
        params.size = state.page.pageSize;
        params.offerCode = state.keywords.offerCode;
        params.ownerCompany = state.keywords.ownerCompany;
        params.inquiryCode = state.keywords.inquiryCode;
        params.status = state.keywords.status;
        params.mtrlCategory = state.keywords.mtrlCategory;

        return new Promise((resolve =>{
            http.post('/supplier-resource/bill/offerInfoPage', params).then((res)=>{
                if(res.data.code === '200') {
                    commit('SET_OFFER_INFO_LIST', res.data.data.records)
                    commit('SET_PAGE_TOTAL', res.data.data.total)
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            })
        }));
    },

    getBillOfferVo: ({commit}, payload) =>{
        let params = {};
        params.id = payload;
        return new Promise((resolve => {
            http.post('/supplier-resource/bill/getBillOfferVo', params).then((res)=>{
                if(res.data.code === '200') {
                    commit('SET_OFFER_INFO', res.data.data)
                    resolve(res.data)
                }else{
                    resolve(res);
                }
            })
        }))
    },

    saveBillOfferInfo: ({commit}, payload) =>{
        return new Promise((resolve => {
            http.postObj('/supplier-resource/bill/saveBillOfferInfo', JSON.stringify(payload)).then((res)=>{
                if(res.data.code === '200') {
                    resolve(res.data)
                }else{
                    resolve(res);
                }
            })
        }))
    },

    toRemote: ({commit}, payload) =>{
        return new Promise((resolve => {
            http.postObj('/supplier-resource/bill/toRemote', JSON.stringify(payload)).then((res)=>{
                if(res.data.code === '200') {
                    resolve(res.data)
                }else{
                    resolve(res);
                }
            })
        }))
    },


    delAttachFile: ({commit}, payload)=>{
        return new Promise((resolve => {
            http.post('/supplier-resource/bill/delAttachFile', payload).then((res)=>{
                if(res.data.code === '200'){
                    resolve(res.data);
                }else{
                    resolve(res);
                }
            })
        }))
    },

    downLoad: ({commit}, payload)=>{
        http.request('/supplier-resource/bill/downLoad', 'post', 'blob', payload).then((res) => {
            if (res.status === 200) {
                if (!res.data) {
                    return false;
                } else {
                    const blob = res.data;
                    const contentDisposition = res.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1]);
                    }
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click(); // 点击下载
                    window.setTimeout(function () {
                        URL.revokeObjectURL(blob);
                        document.body.removeChild(link);
                    }, 0);
                }
            }
        }).catch((reason) => {
            console.log(reason);
        });
    },

    uploadFile: ({commit}, payload) =>{
        return new Promise((resolve => {
            http.fileUpload('/supplier-resource/bill/uploadFile', payload).then((res)=>{
                if(res.data.code === '200') {
                    resolve(res.data);
                }else{
                    resolve(res);
                }
            })
        }))
    }


};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
